// Official brand assets for Apostle Blaise Judah
export const LOGO_CREST = "/logo-crest.png"; // crest emblem (black bg — use mix-blend-screen on dark)
export const LOGO_FULL = "/logo-full.png"; // full lockup with wordmark
export const PORTRAIT =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_faith-lead-ai/artifacts/apjvm8yu_image.png";
// Hero portrait — professional editorial (used in Home hero sidebar)
export const HERO_PORTRAIT =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_faith-lead-ai/artifacts/1insk02q_Apostle%20Blaise%20Judah_%20Visionary%20Leader%201.png";
